"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var review_profile_controller_1 = __importDefault(require("./review-profile.controller"));
var review_student_signup_html_1 = __importDefault(require("./review-student-signup.html"));
var states_1 = require("../../common/constants/states");
var time_1 = require("../../common/helpers/time");
var StudentSignupController = /** @class */ (function () {
    function StudentSignupController(UsersModel, FlashService, SchoolsModel, $q, AuthService, $uibModal, $state) {
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.SchoolsModel = SchoolsModel;
        this.$q = $q;
        this.AuthService = AuthService;
        this.$uibModal = $uibModal;
        this.states = states_1.States;
        this.$state = $state;
        this.submitted = false;
        this.loadingSchools = false;
        this.permitTaken = false;
        this.student = {
            last_minute_text_reminders: "N",
            guardian_last_minute_text_reminders: "N",
            pickuplocation: {
                street: "",
                state: "",
                city: "",
                zip: "",
            },
        };
        this.schoolCodeValid = false;
        this.submitStudent = this.submitStudent.bind(this);
    }
    /**
     * Returns whether or not the form in its current state is valid
     */
    StudentSignupController.prototype.formValid = function () {
        var condition = this.schoolCodeValid === true;
        if (!condition) {
            return false;
        }
        return condition;
    };
    /**
     * Return the student's age based on their DOB
     */
    StudentSignupController.prototype.getStudentAge = function () {
        if (!this.student.dob) {
            return 6470;
        }
        var dob = (0, time_1.parseMMDDYYYYDate)(this.student.dob);
        return (0, time_1.differenceInDays)(new Date(), dob);
    };
    /**
     * Is the student under 18 years old?
     * @returns {boolean}
     */
    StudentSignupController.prototype.studentIsAMinor = function () {
        return this.getStudentAge() < 6570;
    };
    /**
     * Is the student under 21 years old?
     * @returns {boolean}
     */
    StudentSignupController.prototype.studentUnder21 = function () {
        return this.getStudentAge() < 7670;
    };
    /**
     * Force the school code to be upper case and only allow alphanumerics
     */
    StudentSignupController.prototype.formatCode = function () {
        this.student.schoolcode = this.student.schoolcode
            .replace(/[^a-z0-9\s]/gi, "")
            .toUpperCase();
    };
    StudentSignupController.prototype.getSchool = function () {
        var _this = this;
        this.FlashService.clearFlash();
        this.schoolCodeValid = false;
        this.SchoolsModel.getSchoolByCode(this.student.schoolcode).then(function (response) {
            if (response.schoolId) {
                _this.student.schoolId = response.schoolId;
                _this.student.school = response.school;
                _this.school = response.school;
                _this.schoolCodeValid = true;
            }
            else {
                _this.FlashService.setMessage({
                    type: "error",
                    message: response.message,
                });
                _this.schoolCodeValid = false;
            }
        });
    };
    StudentSignupController.prototype.loginNewUser = function (user) {
        return this.$q.when(this.AuthService.manualLogin(user));
    };
    StudentSignupController.prototype.submitStudent = function () {
        var _this = this;
        if (this.submitted === true) {
            return;
        }
        var student = structuredClone(this.student);
        this.submitted = true;
        this.modalInstance.submitted = true;
        var dob = (0, time_1.formatDateTime)((0, time_1.parseMMDDYYYYDate)(student.dob), "YYYY-MM-DD");
        var request = {
            firstname: student.firstname,
            lastname: student.lastname,
            username: student.username,
            password: student.password,
            dob: dob,
            email: student.email,
            schoolcode: student.schoolcode,
            phone: student.phone,
            driving_experience: student.driving_experience,
            pickuplocation: null,
            parent: null,
        };
        if (student.hasOwnProperty("pickuplocation") &&
            student.pickuplocation.street &&
            student.pickuplocation.city &&
            student.pickuplocation.state &&
            student.pickuplocation.zip) {
            request.pickuplocation = student.pickuplocation;
        }
        if (student.hasOwnProperty("parent") &&
            student.parent.firstname &&
            student.parent.lastname &&
            student.parent.email &&
            student.parent.phone) {
            request.parent = student.parent;
        }
        if (request.pickuplocation === null) {
            delete request.pickuplocation;
        }
        if (request.parent === null) {
            delete request.parent;
        }
        this.UsersModel.createStudent(request)
            .then(function (response) {
            _this.loginNewUser(response.student).then(function (res) {
                _this.submitted = false;
                _this.modalInstance.submitted = false;
                _this.modalInstance.dismiss("cancel");
                _this.$state.go("drivecoach.student.dashboard");
                _this.FlashService.setMessage({
                    type: "success",
                    message: response.message,
                });
            });
        })
            .catch(function (response) {
            _this.submitted = false;
            _this.modalInstance.submitted = false;
        });
    };
    StudentSignupController.prototype.reviewProfile = function () {
        var _this = this;
        this.modalInstance = this.$uibModal.open({
            animation: true,
            template: review_student_signup_html_1.default,
            controller: review_profile_controller_1.default,
            controllerAs: "vm",
            size: "sm",
            resolve: {
                student: this.student,
                submit: function () { return _this.submitStudent; },
            },
        });
    };
    return StudentSignupController;
}());
StudentSignupController.$inject = [
    "UsersModel",
    "FlashService",
    "SchoolsModel",
    "$q",
    "AuthService",
    "$uibModal",
    "$state",
];
exports.default = StudentSignupController;
